module.exports = __webpack_public_path__ + "img/img-5.218c1bbd.png";